<template>
  <v-progress-linear v-if="isLoading" indeterminate />
  <!-- <PaymentsHistory :payments="payments" /> -->
  <div v-else>
    <v-card class="text-center mx-3" v-if="userType === 'student'">
      <v-card-text>
        <template v-if="cardDetails">
          <h2>{{ cardDetails.billing_details.name }}</h2>
          <h2 class="mb-3">
            <code>
              {{ cardDetails.card.brand }}••••{{ cardDetails.card.last4 }}
            </code>
          </h2>
        </template>
        <v-btn
          outlined
          to="/add-payment"
          color="primary"
          class="font-weight-bold"
          style="border-style: dashed"
          small
        >
          <v-icon left dark>mdi-credit-card</v-icon>
          {{ !cardDetails ? "Add" : "Update" }} Payment Method
        </v-btn>
      </v-card-text>
    </v-card>
    <History :payments="payments" />
  </div>
</template>
<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'
// import PaymentsHistory from "@/components/payment/PaymentsHistory";
import History from '@/components/payment/History'
export default {
  computed: mapGetters(['user', 'userObj', 'paymentHistory']),
  data () {
    return {
      isLoading: false,
      payments: [],
      cardDetails: null,
      userType: localStorage.getItem('userType')
    }
  },
  methods: {
    ...mapActions(['toggleDialog', 'getPaymentHistory']),
    init () {
      this.isLoading = true
      /** A customer account is required for Stripe before anything */
      var self = this
      if (
        typeof self.user.get('stripeCustomerId') === 'undefined' ||
        self.user.get('stripeCustomerId') === ''
      ) {
        var data = {
          email: this.user.get('customEmail')
        }
        /** call the cloud fundtion */
        Parse.Cloud.run('createStripeCustomer', data)
          .then((results) => {
            var user = new Parse.User()
            user.id = self.user.id
            user.set('stripeCustomerId', results.id)
            user.save()
          })
          .catch((error) => {
            // The object was not retrieved successfully.
            // error is a Parse.Error with an error code and message.
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: error.message
            })
          })
          .finally(() => {
            this.isLoading = false
          })
      }
      /** Check if any payment method already exists */
      if (this.user.get('stripePaymentMethodAdded')) {
        this.isLoading = true
        var mData = {
          paymentMethodId: this.user.get('stripePaymentMethodId')
        }
        Parse.Cloud.run('getPaymentMethodDetails', mData)
          .then((results) => {
            this.cardDetails = results
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.isLoading = false // TODO: need discuss and fix
      }
    }
  },
  components: {
    // PaymentsHistory,
    History
  },
  async created () {
    const self = this
    self.init()

    /** get payment history */
    await self.getPaymentHistory({
      userType: self.userType,
      userId: self.user.id
    })

    if (self.paymentHistory) {
      self.payments = self.paymentHistory
        ? self.paymentHistory.map((history) => {
          if (self.userType === 'instructor') {
            var profile = history.get('senderId')
            var senderId = history.get('senderId').id
          } else {
            profile = history.get('receiverId')
            senderId = history.get('receiverId').id
          }
          return {
            id: history.id,
            studentId: senderId,
            profilePicture: profile.get('profilePicture'),
            name: `${profile.get('firstName')} ${profile.get('lastName')}`,
            email: profile.get('email'),
            // description: history.get('notes'),
            date: this.$moment(history.get('paymentDate')).format('LLL'),
            amount: history.get('amount')
          }
        })
        : []
    }
  }
}
</script>
